<form
  [formGroup]="creationForm"
  (ngSubmit)="onSubmit()"
  class="account-creation"
>
  @if (isSSO) {
    <c-banner
      [style]="'success'"
      iconPositionX="top"
      [message]="'REGISTER.CREATE_PASSWORD_BANNER' | translate"
      [showCloseButton]="false"
    ></c-banner>
  }
  @if (!isSSO && !isHeroB) {
    <div class="form-header">
      <h1 class="form-header__title">
        {{ "REGISTER.FORM_HEADER_TITLE" | translate }}
      </h1>
      <p class="form-header__subtitle">
        {{ "REGISTER.FORM_HEADER_SUBTITLE" | translate }}
      </p>
    </div>
  }
  @if (isSSO) {
    <div class="create-password">
      <h1 class="heading">{{ "REGISTER.CREATE_PASSWORD" | translate }}</h1>
      <p class="password-paragraph">
        {{ "REGISTER.PASSWORD_PARAGRAPH" | translate }}
      </p>
    </div>
  }

  <div class="flex-form-fields">
    @if (
      warningState().isWarningActive &&
      warningState().warningMessage ===
        "REGISTER.GENERIC_FORM.ERRORS.ALREADY_REGISTERED"
    ) {
      <c-banner
        [style]="'warning'"
        [inline]="false"
        [showIcon]="false"
        [showCloseButton]="false"
      >
        <div class="banner-warning-message">
          <b>{{
            "REGISTER.GENERIC_FORM.ERRORS.ALREADY_REGISTERED" | translate
          }}</b>
          {{ "REGISTER.GENERIC_FORM.ERRORS.PLEASE" | translate }}
          <a class="banner-warning-message__link" [routerLink]="['/login']">
            {{
              "REGISTER.GENERIC_FORM.ERRORS.ALREADY_REGISTERED_LOG_IN"
                | translate
            }}</a
          >
          {{
            "REGISTER.GENERIC_FORM.ERRORS.ALREADY_REGISTERED_PART_2" | translate
          }}
          <a
            class="banner-warning-message__link"
            [routerLink]="['/forgot-password']"
            >{{
              "REGISTER.GENERIC_FORM.ERRORS.ALREADY_REGISTERED_PASSWORD"
                | translate
            }}</a
          >
          {{
            "REGISTER.GENERIC_FORM.ERRORS.ALREADY_REGISTERED_PART_3" | translate
          }}
        </div>
      </c-banner>
    }
    @if (
      warningState().isWarningActive &&
      warningState().warningMessage ===
        "REGISTER.GENERIC_FORM.ERRORS.MEMBER_ID_MISMATCH"
    ) {
      <c-banner
        [style]="'warning'"
        [inline]="false"
        [showIcon]="false"
        [showCloseButton]="false"
      >
        <div class="banner-warning-message">
          {{ "REGISTER.GENERIC_FORM.ERRORS.MEMBER_ID_MISMATCH" | translate }}
        </div>
      </c-banner>
    }

    @if (errorState().isErrorActive) {
      <c-banner [style]="'error'" [inline]="false" [showCloseButton]="false">
        <div class="banner-error-message">
          {{ errorState().errorMessage | translate }}
          @if (
            errorState().errorMessage ===
            "REGISTER.GENERIC_FORM.ERRORS.GENERIC_SERVER_ERROR"
          ) {
            <span class="banner-error-message-email-link">
              <a
                href="mailto:support@cariloop.com"
                title="Contact Cariloop Support at support@cariloop.com"
              >
                support&#64;cariloop.com
              </a>
              .
            </span>
          }
        </div>
      </c-banner>
    }

    <div class="full-name">
      <div class="input__container">
        <c-input-text
          class="name-input"
          name="firstName"
          type="text"
          required
          [label]="'REGISTER.GENERIC_FORM.FIRST_NAME' | translate"
          [placeholder]="
            'REGISTER.GENERIC_FORM.FIRST_NAME_PLACEHOLDER' | translate
          "
          formControlName="firstName"
          inputID="firstNameInput"
          autocomplete="given-name"
        >
        </c-input-text>
        <div role="alert">
          @if (
            creationForm.get("firstName").touched &&
            !creationForm.get("firstName").valid
          ) {
            <span class="input__error-text">
              @if (creationForm.get("firstName").errors) {
                <p>
                  {{ "REGISTER.GENERIC_FORM.ERRORS.FIRST_NAME" | translate }}
                </p>
              }
            </span>
          }
        </div>
      </div>

      <div class="input__container">
        <c-input-text
          class="name-input"
          name="lastName"
          type="text"
          required
          [label]="'REGISTER.GENERIC_FORM.LAST_NAME' | translate"
          [placeholder]="
            'REGISTER.GENERIC_FORM.LAST_NAME_PLACEHOLDER' | translate
          "
          formControlName="lastName"
          inputID="lastNameInput"
          autocomplete="family-name"
        >
        </c-input-text>
        <div role="alert">
          @if (
            creationForm.get("lastName").touched &&
            !creationForm.get("lastName").valid
          ) {
            <span class="input__error-text">
              @if (creationForm.get("lastName").errors) {
                <p>
                  {{ "REGISTER.GENERIC_FORM.ERRORS.LAST_NAME" | translate }}
                </p>
              }
            </span>
          }
        </div>
      </div>
    </div>

    @if (needsMemberId) {
      <div class="member-id">
        <c-input-text
          class="member-id__input"
          name="memberId"
          type="text"
          required
          [label]="memberIdLabel()"
          [placeholder]="memberIdPlaceholderText()"
          formControlName="memberId"
          inputID="memberIdInput"
          autocomplete="off"
        >
        </c-input-text>
        <div role="alert">
          @if (
            creationForm.get("memberId").touched &&
            creationForm.get("memberId").invalid
          ) {
            <span class="input__error-text">
              <p>{{ memberIdError() }}</p>
            </span>
          }
        </div>
      </div>
    }

    <div class="email-group">
      <div class="email-input">
        <label for="email" class="input-label">
          <span>{{ "REGISTER.GENERIC_FORM.EMAIL.ADDRESS" | translate }}</span>
        </label>
        <c-input-text
          #emailInput
          inputID="email"
          name="email"
          type="email"
          [placeholder]="
            'REGISTER.GENERIC_FORM.EMAIL.ADDRESS_PLACEHOLDER' | translate
          "
          formControlName="email"
          required
          autocomplete="email"
        >
        </c-input-text>
      </div>
      <div role="alert">
        @if (
          creationForm.get("email").touched && !creationForm.get("email").valid
        ) {
          <span class="input__error-text">
            @if (creationForm.get("email").errors?.required) {
              <p>
                {{ "REGISTER.GENERIC_FORM.ERRORS.EMAIL.MISSING" | translate }}
              </p>
            }
            @if (creationForm.get("email").errors?.pattern) {
              <p>
                {{ "REGISTER.GENERIC_FORM.ERRORS.EMAIL.INVALID" | translate }}
              </p>
            }
          </span>
        }
      </div>
      @if (
        creationForm.get("email").touched &&
        isValidEmail(creationForm.get("email").value) &&
        showEmailTypeSelector
      ) {
        <div class="email-type">
          <div class="container-arrow"></div>
          <label for="email-type" class="label">
            {{
              "REGISTER.GENERIC_FORM.EMAIL.PERSONAL_OR_WORK.QUESTION"
                | translate
            }}
          </label>
          <mat-radio-group
            name="email-type"
            id="email-type"
            formControlName="emailType"
            class="radio-group"
            [ngClass]="{
              invalid: creationForm.get('emailType').errors?.required,
            }"
          >
            <mat-radio-button value="personal">
              {{
                "REGISTER.GENERIC_FORM.EMAIL.PERSONAL_OR_WORK.PERSONAL"
                  | translate
              }}
            </mat-radio-button>
            <mat-radio-button value="work">
              {{
                "REGISTER.GENERIC_FORM.EMAIL.PERSONAL_OR_WORK.WORK" | translate
              }}
            </mat-radio-button>
          </mat-radio-group>
        </div>
      }
      <div aria-live="polite">
        @if (
          creationForm.get("emailType").errors?.required &&
          !creationForm.get("email").errors
        ) {
          <span class="input__error-text">
            {{ "REGISTER.GENERIC_FORM.ERRORS.EMAIL_TYPE" | translate }}
          </span>
        }
      </div>
    </div>
    <div>
      <c-input-text
        [label]="'REGISTER.GENERIC_FORM.PASSWORD.PASSWORD' | translate"
        [placeholder]="
          'REGISTER.GENERIC_FORM.PASSWORD.PASSWORD_PLACEHOLDER' | translate
        "
        formControlName="password"
        name="password"
        inputID="password-input"
        autocomplete="new-password"
        required="true"
        passwordVisibility
        showText="{{ 'LOGIN.PASSWORD_VISIBILITY_OFF' | translate }}"
        hideText="{{ 'LOGIN.PASSWORD_VISIBILITY_ON' | translate }}"
      >
        @if (creationForm.get("password").errors?.knownBadPassword) {
          <p>
            {{ "REGISTER.GENERIC_FORM.ERRORS.PASSWORD_COMMON" | translate }}
          </p>
        }
        <div role="alert" error-container>
          @if (
            creationForm.get("password").touched &&
            !creationForm.get("password").valid
          ) {
            <span class="input__error-text">
              @if (creationForm.get("password").errors?.required) {
                <p>
                  {{ "REGISTER.GENERIC_FORM.ERRORS.PASSWORD" | translate }}
                </p>
              }
            </span>
          }
        </div>
        <c-password-strength-indicator
          content
          [control]="creationForm.get('password')"
          [passwordComplexity]="passwordComplexity"
        />
      </c-input-text>
    </div>
  </div>

  <div class="checkbox__terms-container">
    <div class="checkbox__terms">
      <mat-checkbox
        formControlName="termsAndPrivacy"
        required
        [ngClass]="{
          invalid:
            creationForm.get('termsAndPrivacy').errors?.required &&
            creationForm.get('termsAndPrivacy').touched,
        }"
        aria-labelledby="terms-description"
      >
      </mat-checkbox>
      <p id="terms-description">
        <span class="checkbox__terms-description">{{
          "GENERAL.AGREE" | translate
        }}</span>
        <a
          class="checkbox__terms-description"
          href="https://www.cariloop.com/terms-of-service/"
          target="_blank"
          >{{ "GENERAL.TOS" | translate }}</a
        >
        <span class="checkbox__terms-description">{{
          "GENERAL.AND" | translate
        }}</span>
        <a
          class="checkbox__terms-description"
          href="https://www.cariloop.com/privacy-policy/"
          target="_blank"
          >{{ "GENERAL.PRIVACY" | translate }}</a
        >
      </p>
    </div>
    <div role="alert">
      @if (
        creationForm.get("termsAndPrivacy").errors?.required &&
        creationForm.get("termsAndPrivacy").touched
      ) {
        <span class="input__error-text">
          {{ "GENERAL.TOS_ERROR" | translate }}
        </span>
      }
    </div>
  </div>
  @if (!isLoading && !isSSO) {
    <button
      cari-button
      type="submit"
      data-shape="squared"
      data-type="neutral"
      data-style="fill"
      data-size="x-large"
      class="brand-submit-btn"
    >
      {{ "REGISTER.GENERIC_FORM.GET_STARTED" | translate }}
    </button>
  }
  @if (!isLoading && isSSO) {
    <button
      cari-button
      type="submit"
      data-shape="squared"
      data-type="neutral"
      data-style="fill"
      data-size="x-large"
      class="brand-submit-btn"
    >
      {{ "REGISTER.CONTINUE" | translate }}
    </button>
  }
  @if (isLoading) {
    <img src="assets/img/loader.png" alt="Loading" class="loading" />
  }
</form>

@if (!isMobileWebView && !isSSO) {
  <p class="login-code-text">
    {{ "REGISTER.LOG_IN_TEXT" | translate }}
    <a [routerLink]="['/login']">
      {{ "REGISTER.LOG_IN_LINK" | translate }}
    </a>
  </p>
}
